<template>
  <section class="banner">
    <div class="container">
      <a-typography-title :level="1">
        东数西算解决方案
      </a-typography-title>
      <a-typography-paragraph>
        {{
          '支持以极低成本将业务数据在线传输至西部数据中心，10分钟传输10TB数据，' +
          '降低企业对数据中心的投资运营成本，更好地为数字化发展赋能。'
        }}
      </a-typography-paragraph>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_1"
                  @click="localTo('https://dtexpress.galaxy-future.com/#/login')">
          免费体验
        </a-button>
        <a-button type="link" class="button_n_1"
                  @click="$Store.Page().openModal('modalFormCollection','demo')">
          预约咨询
        </a-button>
        <a-button type="link" class="button_n_2 button_n_2_w"
                  @click="$Store.Page().openModal('modalVideo',href.video)">
          <template #icon>
            <PlayCircleOutlined />
          </template>
          观看视频
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { PlayCircleOutlined } from '@ant-design/icons-vue';

import { DataInterface } from '@interface/public';

export default {
  name: 'plan_banner',
  components: {
    PlayCircleOutlined
  },
  data(): DataInterface {
    return {
      href: {
        video: 'https://gf-files-lf.oss-cn-beijing.aliyuncs.com/video/data-transfer-cross-region.mp4'
      }
    };
  },
  methods: {
    localTo(url:string):void{
      window.open(url,'_blank')
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/planMigrate/';

.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  .bg('@{image}banner.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: 150px 0 80px;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(justify, @banner_title, @color_white, @banner_title, true);
}

div.ant-typography {
  max-width: 500px;
  margin: 20px 0 0;
  .font(justify, @text+@line, @color_white, @text);
}

.ant-space {
  margin: 20px 0 0;
}

@media screen and (max-width: -1px+@grid_xl) {
  .banner {
    .container {
      padding: 80px 0 30px;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  h1.ant-typography {
    .font(justify, @banner_title_mo, @color_white, @banner_title_mo, true);
  }
  
  div.ant-typography {
    margin: @margin_mo 0 0;
    .font(justify, @text_mo+@line_mo, @color_white, @text_mo);
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
  }
}

@media screen and (max-width: -1px+@grid_xs) {
  .banner {
    background-position: center left !important;
  }
}
</style>